import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";
import { waLink } from "../lib/whatsapp";

export const FinalCTA = () => (
  <section className="bg-teal-dark py-24 lg:py-32" data-testid="final-cta-section">
    <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
      <Reveal>
        <div className="flex justify-center">
          <SectionTag icon={MessageCircle} label="Vamos conversar" tone="light" />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-cream leading-tight">
          Precisa entender seu caso com segurança?
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-6 text-base md:text-lg text-cream/70 max-w-lg mx-auto leading-relaxed">
          Fale com as advogadas e receba uma orientação inicial com clareza e
          atenção.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <a
          href={waLink("Olá! Gostaria de agendar um atendimento com as advogadas.")}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 inline-flex items-center gap-2 bg-cream text-ink px-8 py-4 font-mono text-xs uppercase tracking-[0.15em] hover:bg-brown-dark hover:text-cream transition-colors duration-300"
          data-testid="final-cta-button"
        >
          Agendar atendimento
          <ArrowUpRight size={16} />
        </a>
      </Reveal>
    </div>
  </section>
);
